import { SxProps } from "@mui/material";

export const sxSubtitle: SxProps = {
  fontSize: 16,
	fontFamily: 'Unimed-Sans',
  color: '#4C4C4C',
  textAlign: 'left',
	maxWidth: '80%',
	'@media (max-width: 720px)': {
		maxWidth: '100%'
	}
}

export const sxButtonConsultar: SxProps = {
	borderRadius: '80px',
	height: '44px',
	padding: '24px 32px',
	'@media (max-width: 720px)': {
			width: 'stretch'
	}
}